/**
 * i18n messages for the certification module (en/ar). Registered in
 * core/plugins/i18n.ts via deep merge (same pattern as expenseTrackerMessages).
 * CSP-safe compiler: only `{named}` placeholders — no plurals, no linked messages.
 */
export const certificationMessages = {
  en: {
    certification: {
      publicLink: {
        label: "Public verification link",
        notGenerated: "Not generated",
        generate: "Generate link",
        copy: "Copy link",
        revoke: "Revoke link",
        dormantWarning:
          "This link is dormant because the certificate is not active. It will start working again automatically if the certificate is re-activated.",
        confirm: {
          title: "Revoke this verification link?",
          text: "This permanently kills the URL. Any QR code already printed on paper will stop working, and generating a new link afterwards produces a different URL that the old printed code will not match.",
          confirmButtonText: "Yes, revoke it",
          cancelButtonText: "Cancel",
          cancelledText: "The link was not revoked.",
        },
        toast: {
          generated: "Public link generated.",
          revoked: "Public link revoked.",
          copied: "Link copied to clipboard.",
          loadError: "Could not load the public link.",
          generateError: "Could not generate the public link.",
          revokeError: "Could not revoke the public link.",
          copyError: "Could not copy the link.",
          notActiveTitle: "Certificate is not active",
          notActiveMessage:
            "Activate the certificate first, then generate the link.",
        },
      },
      // Under a name the form filled in itself (spec 3a).
      nameSuggestion: { suggested: "Suggested" },
    },
  },
  ar: {
    certification: {
      publicLink: {
        label: "رابط التحقق العام",
        notGenerated: "لم يتم إنشاؤه",
        generate: "إنشاء الرابط",
        copy: "نسخ الرابط",
        revoke: "إلغاء الرابط",
        dormantWarning:
          "هذا الرابط معطّل مؤقتًا لأن الشهادة غير نشطة. سيعمل تلقائيًا مرة أخرى عند إعادة تفعيل الشهادة.",
        confirm: {
          title: "هل تريد إلغاء رابط التحقق هذا؟",
          text: "سيؤدي هذا إلى إبطال الرابط نهائيًا. أي رمز QR مطبوع مسبقًا سيتوقف عن العمل، وإنشاء رابط جديد لاحقًا سينتج عنه رابط مختلف لا يطابق الرمز المطبوع القديم.",
          confirmButtonText: "نعم، ألغِ الرابط",
          cancelButtonText: "إلغاء",
          cancelledText: "لم يتم إلغاء الرابط.",
        },
        toast: {
          generated: "تم إنشاء الرابط العام.",
          revoked: "تم إلغاء الرابط العام.",
          copied: "تم نسخ الرابط إلى الحافظة.",
          loadError: "تعذّر تحميل الرابط العام.",
          generateError: "تعذّر إنشاء الرابط العام.",
          revokeError: "تعذّر إلغاء الرابط العام.",
          copyError: "تعذّر نسخ الرابط.",
          notActiveTitle: "الشهادة غير نشطة",
          notActiveMessage: "قم بتفعيل الشهادة أولاً، ثم أنشئ الرابط.",
        },
      },
      // Under a name the form filled in itself (spec 3a).
      nameSuggestion: { suggested: "مقترح" },
    },
  },
};
